module.exports = __webpack_public_path__ + "static/Partnering-bffff44ae1c262ced62830e19bc9854e.png";